<template>
  <div ref="container">
    <a-modal :title="title" :width="1300" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:20%;height:80%;">

      <a-table :loading="loading" :dataSource="dataSource" :pagination="ipagination" :columns="columns" @change="handleTableChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
        <span slot="action" slot-scope="text, record">
          <a @click="myHandleDetailPI(record)">PI列表</a>
        </span>
        <span slot="startDate" slot-scope="text, record">
          <span>{{changeDate(record.startDate)}}</span>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { listCertificate } from '@/api/api'
export default {
  name: 'VendorModal',
  components: {},
  data() {
    return {
      title: '注册证',
      visible: false,
      model: {},
      dataSource: [],
      loading: false,
      id: '',
      selectedRowKeys: [],
      specificationId: '',
      selectionRows: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns: [
        {
          title: '注册/备案人',
          dataIndex: 'registerName',
        },
        {
          title: '注册/备案号',
          dataIndex: 'registerNo',
        },
      ],
    }
  },
  created() {},
  methods: {
    handleOk() {
      console.log(this.selectionRows, '数组')
      let obj = {
        registerNameList: [],
        registerNoList: [],
      }
      obj.registerNameList = this.selectionRows.map((it) => {
        return it.registerName
      })
      obj.registerNoList = this.selectionRows.map((it) => {
        return it.registerNo
      })
      this.$emit('change', obj)
      this.handleCancel()
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    async add(e) {
      // console.log(e, 'e1')
      this.visible = true
      this.ipagination.pageSize = 10
      this.selectedRowKeys = []
      this.getlist()
    },
    async getlist() {
      let params = {
        page: this.ipagination.current,
        limit: this.ipagination.pageSize,
      }
      this.loading = true
      const res = await listCertificate(params)
      console.log(res, 'res')
      if (res.errno == 200 && res.errmsg == '成功') {
        // res.data.forEach((it) => {
        //   it.materialName = e.name
        // })
        this.dataSource = res.data.list
        this.ipagination.total = res.data.total
        this.loading = false
      } else {
        this.$message.error(res.data || res.errmsg)
        this.loading = false
      }
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      if (pagination && pagination.current) {
        this.ipagination = pagination
      }
      this.getlist()
    },
    async myHandleDetailPI(record) {
      this.$refs.PIreorcdref.add(record)
    },
    close() {
      this.visible = false
    },
    // handleOk() {
    //   // 触发表单验证
    //   this.handleCancel()
    // },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
</style>